<p-dialog
  [visible]="visible"
  (visibleChange)="$event ? null : close()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{ width: '480px', maxWidth: '95vw' }"
  styleClass="payment-date-dialog"
  header="Corregir fecha del pago"
>
  <div class="pd-body" *ngIf="target">
    <div class="pd-resumen">
      <span class="pd-label">Pago</span>
      <span class="pd-valor"
        >{{ target.monto | currency: 'MXN' : 'symbol' : '1.2-2' }}<span *ngIf="target.trackingKey"> · {{ target.trackingKey }}</span></span
      >
      <span class="pd-hint" *ngIf="target.cliente"
        >{{ target.cliente }} · depósito capturado el {{ target.fecha | date: 'dd/MM/yyyy' : 'UTC' }}</span
      >
    </div>

    <div class="field">
      <label for="pd-fecha">Fecha real del depósito</label>
      <p-calendar
        inputId="pd-fecha"
        [(ngModel)]="newDate"
        dateFormat="dd/mm/yy"
        [showIcon]="true"
        appendTo="body"
        [maxDate]="hoy"
        [style]="{ width: '100%' }"
      ></p-calendar>
    </div>

    <div class="field">
      <label for="pd-motivo">Motivo <span class="pd-req">*</span></label>
      <textarea
        id="pd-motivo"
        pInputTextarea
        rows="3"
        [(ngModel)]="reason"
        [autoResize]="true"
        placeholder="Ej. La fecha registrada era la de captura; el estado de cuenta de Covalto muestra el depósito el 03/06"
      ></textarea>
      <small class="pd-ayuda" [class.is-error]="reason && !reasonValid"
        >Mínimo 10 caracteres. Queda en la bitácora del pago y de cada arrendamiento donde está aplicado.</small
      >
    </div>

    <div class="pd-aviso">
      <i class="fa-solid fa-circle-info"></i>
      Cambia los días de retraso de las letras que cubre este pago. No mueve montos ni saldos.
    </div>

    <div class="pd-error" *ngIf="error"><i class="fa-solid fa-triangle-exclamation"></i> {{ error }}</div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text" (click)="close()"></button>
    <button
      pButton
      type="button"
      label="Corregir fecha"
      icon="fa-solid fa-calendar-check"
      class="p-button-success"
      [disabled]="!canSave"
      [loading]="saving"
      (click)="save()"
    ></button>
  </ng-template>
</p-dialog>
